module.exports = __webpack_public_path__ + "files/2b9b8b07ede80b80a0d5ef64ea4a40a2.png";